"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertKeyToSnakeCase = void 0;
var mapKeys_1 = __importDefault(require("lodash/mapKeys"));
var snakeCase_1 = __importDefault(require("lodash/snakeCase"));
function convertKeyToSnakeCase(obj) {
    return mapKeys_1.default(obj, function (v, k) { return snakeCase_1.default(k); });
}
exports.convertKeyToSnakeCase = convertKeyToSnakeCase;
//# sourceMappingURL=util.js.map


// WEBPACK FOOTER //
// /static/node_modules/@ridi/event-client/dist/cjs/utils/util.js